<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ selected }}</span>
		<app-button
			(click)="createBrokerage()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			>Create brokerage</app-button
		>
	</div>
</ng-template>

<ng-template #brokerageTemplate let-item>
	<div class="flex flex-col">
		<span class="font-bold truncate">{{ item.name | titlecase }}</span>
		<div class="flex truncate">
			<span class="text-sm"
				>{{ item.address?.street }}, {{ item?.address?.city }}</span
			>
		</div>
	</div>
</ng-template>

<ng-template #brokerTemplate let-item>
	<div class="flex text-truncate">
		<atomic-name-badge
			[firstName]="item.firstName"
			[lastName]="item.lastName"
			size="small"
		></atomic-name-badge>
		<div class="flex flex-col ml-2 truncate">
			<span class="font-bold whitespace-nowrap"
				>{{ item.firstName | titlecase }} {{ item.lastName | titlecase }}</span
			>
			<span class="text-sm whitespace-nowrap">{{
				item.brokerage | capitalize
			}}</span>
		</div>
	</div>
</ng-template>

<app-auto-complete
	(onSelect)="onSelect($event)"
	placeholder="Mortgage brokerage"
	[itemGroups]="[
		{ items: [{ value: 'createNew' }], template: createNewTemplate },
		{
			items: (mortgageBrokerages$ | async),
			template: brokerageTemplate,
			title: 'Mortgage brokerages',
			noResultsMessage: 'No brokerages found',
			type: dropdownOptions.SELECT_MORTGAGE_BROKERAGE,
		},
		{
			items: (mortgageBrokers$ | async),
			template: brokerTemplate,
			title: 'Mortgage brokers',
			type: dropdownOptions.SELECT_MORTGAGE_BROKER,
		},
	]"
	[(ngModel)]="selected"
	name="dual-dropdown-1"
	[minSearchTerm]="2"
	(debounce)="search($event)"
	[loading]="loading"
	width="w-full"
>
</app-auto-complete>
